import { cn } from "@/lib/utils";
import { Card } from "@/components/ui/card";

export const StatCard = ({ label, value, sub, icon: Icon, tone = "default", className }) => {
  const toneMap = {
    default: "text-foreground",
    danger:  "text-primary",
    warning: "text-warning",
    success: "text-success",
    info:    "text-info",
  };
  return (
    <Card className={cn("relative overflow-hidden bg-card/60 border-border p-5 group hover:border-primary/40 transition-colors", className)}>
      <div className="absolute -right-6 -top-6 opacity-5 group-hover:opacity-10 transition-opacity">
        {Icon && <Icon className="h-28 w-28" />}
      </div>
      <div className="flex items-start justify-between mb-3">
        <div className="font-mono text-[10px] tracking-widest text-muted-foreground uppercase">{label}</div>
        {Icon && <Icon className={cn("h-4 w-4", toneMap[tone])} />}
      </div>
      <div className={cn("text-3xl font-bold tracking-tight font-mono", toneMap[tone])}>{value}</div>
      {sub && <div className="mt-1 text-xs text-muted-foreground">{sub}</div>}
    </Card>
  );
};

export default StatCard;
